import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { EntrySectionDTO, IEntrySectionDTO } from './entry.section.dto';
import { IYearDTO, YearDTO } from './year.dto';

export interface IEntryDTO extends IBaseEntityDTO {
  year: IYearDTO;
  sections: IEntrySectionDTO[];
}

export class EntryDTO extends BaseEntityDTO implements IEntryDTO {
  year: IYearDTO;
  sections: IEntrySectionDTO[];
  constructor(data?: Partial<EntryDTO>) {
    super();
    this.year = new YearDTO(data?.year);

    this.sections = data?.sections
      ? data.sections.map((section) => new EntrySectionDTO(section))
      : [];
  }
}
